export default {
    Developer: "all",
    Developer: ["Paul", "jml"],
}